class ResponseMessageHandler {
  constructor() {
    this.list = {
      general_issue: 'Something want wrong, Contact System admin.',
    };
  }

  show(key) {
    return this.list[key];
  }
}
const responseMessageHandler = new ResponseMessageHandler();
export default responseMessageHandler;
